// Lib dependencies
import React from 'react';
import { useLocation } from 'react-router-dom';

// Providers
import LanguageProvider from './i18n/providers/LanguageProvider/LanguageProvider';
import EntityProvider from './providers/EntityProvider';
import MantineProvider from './mantine/providers/MantineProvider';
import ModalsProvider from './mantine/providers/ModalsProvider';
import GlobalStylesProvider from './mantine/providers/GlobalStylesProvider';

// Router
import Router from './router';
import routesPaths from './router/configs/routesPaths.configs';

const App = () => {
  const { pathname } = useLocation();

  React.useEffect(() => {
    window.addEventListener('error', (e) => {
      if (e.message === 'ResizeObserver loop limit exceeded') {
        const resizeObserverErrDiv = document.getElementById('webpack-dev-server-client-overlay-div');
        const resizeObserverErr = document.getElementById('webpack-dev-server-client-overlay');
        if (resizeObserverErr) {
          resizeObserverErr.setAttribute('style', 'display: none');
        }
        if (resizeObserverErrDiv) {
          resizeObserverErrDiv.setAttribute('style', 'display: none');
        }
      }
    });
  }, []);

  return (
    <MantineProvider>
      <ModalsProvider>
        <GlobalStylesProvider />
        <LanguageProvider>
          {pathname !== routesPaths.notFound && pathname !== routesPaths.entityNotFound ? (
            <EntityProvider>
              <Router />
            </EntityProvider>
          ) : (
            <Router />
          )}
        </LanguageProvider>
      </ModalsProvider>
    </MantineProvider>
  );
};

export default App;
